import React from 'react';
import Proptypes from 'prop-types';

import { getSaxsExtendedSubtractionsByExperimentId, getSaxsSubtractionsAsListByDataCollectionIds, getSaxsSubtractionAsListBySubtractionId } from './IORequests';
import { parseSubtractions, parseSubtractions2 } from '../../../helpers/Saxs/SaxsSubtractionsMapper';

/**
 * React container which can get subtractions. It can get them:
 * - from a list of subtractions identifiers provided in  this.props.subtractionIds
 * - from a list of dataCollection identifiers provided in  this.props.dataCollectionId
 * - from a list of experiment identifiers provided in  this.props.experimentId
 */
class SaxsSubtractionsContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            experimentId: null,
            dataCollectionId: null,
            subtractionIds: null,
            fetching: true,
            fetched: false,
            subtractions: [],
        }

        this.getSubtractions = this.getSubtractions.bind(this);
    }

    render() {
        if ((this.props.subtractionIds && this.state.subtractionIds != this.props.subtractionIds)
            || (this.props.experimentId && this.state.experimentId != this.props.experimentId)
            || (this.props.dataCollectionId && this.state.dataCollectionId != this.props.dataCollectionId)) {
            this.getSubtractions();
        }
        return this.props.children(this.state.subtractions);
    }

    /** Get all datasets associated to a given experimentId */
    getSubtractions() {
        const onSuccess = (response) => {

            const getparsedSubtractions = (data) => {
                // if (this.props.experimentId) { return parseSubtractions(data) }
                // if (this.props.dataCollectionId) { return parseSubtractions(data) }
                if (this.props.subtractionIds) { return parseSubtractions2(data) }
            }

            this.setState({
                subtractions: getparsedSubtractions(response.data), // store mapped data no raw data.
                experimentId: this.props.experimentId ? this.props.experimentId : null,
                dataCollectionId: this.props.dataCollectionId ? this.props.dataCollectionId : null,
                subtractionIds: this.props.subtractionIds ? this.props.subtractionIds : null,
                fetching: false,
                fetched: true
            });
        }

        const onError = (error) => {
            debugger;
            this.setState({
                error: error,
                fetching: false,
                fetched: false
            });
        }

        if (this.props.experimentId) {
            getSaxsExtendedSubtractionsByExperimentId(this.props.token, this.props.proposal, this.props.experimentId, onSuccess, onError);
        } else {
            if (this.props.dataCollectionId) {
                getSaxsSubtractionsAsListByDataCollectionIds(this.props.token, this.props.proposal, this.props.dataCollectionId, onSuccess, onError);
            } else {
                if (this.props.subtractionIds) {
                    getSaxsSubtractionAsListBySubtractionId(this.props.token, this.props.proposal, this.props.subtractionIds, onSuccess, onError);
                }
            }
        }
    }
}

export default SaxsSubtractionsContainer;


SaxsSubtractionsContainer.prototypes = {
    /** datacollection identifier. Use dataCollectionId or experimentId props */
    dataCollectionId: Proptypes.number,
    /** experiment identifier.Use dataCollectionId or experimentId props */
    experimentId: Proptypes.number,
    /** proposal name */
    proposal: Proptypes.string,
    /** ispyb backend authentication token */
    token: Proptypes.string
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsSubtractionsContainer.js